import { AUTH_USER, SIGNIN_SUCCESS } from '../types';

const initialState = {
  auth: false,
  companyProfile: JSON.parse(sessionStorage.getItem('companyProfile')),
  profile: JSON.parse(sessionStorage.getItem('profile')),
  token: sessionStorage.getItem('token')
};

export default function AuthReducers(state = initialState, action) {
  switch (action.type) {
    case AUTH_USER:
      return {
        ...state,
        auth: action.payload
      };
    case SIGNIN_SUCCESS:
      return {
        ...state,
        profile: action.payload.data,
        token: action.payload.token
      };
    default:
      return state;
  }
}
